import { IconProps } from "@/data/types";

export default function MapPinIcon({ width = 35, height = 60, color = "#1B1D2B", className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke={color} strokeWidth="0.72" strokeLinecap="round" strokeLinejoin="bevel">
        <path d="M12.76,1.6c-.25,0-.51,0-.76,0s-.51,0-.76,0c-5,.49-7.68,6.14-5.31,10.54L11.23,22a.87.87,0,0,0,1.54,0l5.3-9.83C20.44,7.74,17.73,2.09,12.76,1.6Z" />
        <rect x="9.5" y="6" width="5" height="5" rx="2.5" />
      </svg>
    </div>
  );
}
